import { isString } from 'lodash-es';
import { FeedbackFormValues } from './FeedbackForm';

export function feedbackFormValues2submitValues(values: FeedbackFormValues) {
  const { msgId, messageType, textContent, imageContent, ...otherMessageFields } =
    values.message || ({} as Conversation.Message);

  const submitValues: Feedback.ReportCase = {
    ...values,
    message: {
      ...otherMessageFields,
      extra:
        otherMessageFields?.extra && !isString(otherMessageFields.extra)
          ? JSON.stringify(otherMessageFields.extra)
          : otherMessageFields.extra,
      msgId: msgId.startsWith('nim') ? '-1' : msgId,
      messageType,
      textContent: messageType === 'IMAGE_WITH_TEXT' ? undefined : textContent,
      imageContent: messageType === 'IMAGE_WITH_TEXT' ? undefined : imageContent,
    },
    caseCategory: values.caseCategory || '',
    reason: values.reason || '',
  };

  return submitValues;
}
